var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-myschedule-capsule ds-multi-ellipsis-1",
      style: _vm.scheduleStyle(_vm.schedule),
      attrs: { title: _vm.getScheduleTitle(_vm.schedule) },
      on: {
        click: function ($event) {
          return _vm.goDetails(_vm.schedule)
        },
      },
    },
    [
      _c("span", { style: _vm.scheduleAbbreStyle(_vm.schedule) }, [
        _vm._v(_vm._s(_vm.schedule.agendaTypeVo.abbre)),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.schedule.theme))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }